import React, { useEffect } from "react";

// Extend the window interface to include EBWidgets
declare global {
  interface Window {
    EBWidgets: any;
  }
}

const EventbriteWidget: React.FC = () => {
  useEffect(() => {
    // Load the Eventbrite widget script
    const script = document.createElement("script");
    script.src = "https://www.eventbrite.com/static/widgets/eb_widgets.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      // Once the script is loaded, create the widget
      const exampleCallback = () => {
        console.log("Order complete!");
      };

      if (window.EBWidgets) {
        window.EBWidgets.createWidget({
          // Required
          widgetType: "checkout",
          eventId: "1047819405047",
          iframeContainerId: "eventbrite-widget-container-1047819405047",

          // Optional
          iframeContainerHeight: 425, // Widget height in pixels. Defaults to a minimum of 425px if not provided
          onOrderComplete: exampleCallback, // Method called when an order has successfully completed
        });
      }
    };

    // Cleanup script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="eventbrite-widget-container-1047819405047" />;
};

export default EventbriteWidget;
